import { api } from './index';

const ProviderRequestService = {
	index(params) {
		return api.get('provider', params);
	},
	show(id, params) {
		return api.get('provider/' + id, params);
	},
	store(params) {
		return api.post('provider', params);
	},
	update(id, params) {
		return api.post('provider/' + id, params);
	},
	delete(id) {
		return api.delete('provider/'+id)
	},
	getDocument(id) {
		return api.get('provider/get-document/' + id);
	},
	getCompany(id) {
		return api.get('provider/get-company/' + id);
	},
	getDocumentCategories() {
		return api.get('provider/get-document-categories');
	}
};

export default ProviderRequestService;